import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../Button/Button';
import { ParentalControlsHeader } from '../../shared/ParentalControlHeader/ParentalControlsHeader';
import { PinInputs } from '../../shared/PinInputs/PinInputs';

import type { FC } from 'react';

import * as styles from './ActivatedParentalControls.module.scss';

interface ActivatedParentalControlsProps {
  code?: string;
  handleUnlock?: () => void;
}

const ActivatedParentalControls: FC<ActivatedParentalControlsProps> = ({
  code,
  handleUnlock,
}) => {
  const { t } = useTranslation();
  const [isActivationCodeCorrect, setIsActivationCodeCorrect] = useState(false);
  const [isActivationCodeIncorrect, setIsActivationCodeIncorrect] =
    useState(false);
  const [isHelpTextVisible, setHelpTextVisible] = useState(false);

  return (
    <>
      <ParentalControlsHeader
        titleText={t('Parental controls activated')}
        subtitleText={t('Enter code to view content')}
      />
      <PinInputs
        codeToValidate={code}
        checkPinCorrection={setIsActivationCodeCorrect}
        checkPinIncorrect={setIsActivationCodeIncorrect}
      />
      {isActivationCodeIncorrect && (
        <div className={styles.contact}>
          {!isHelpTextVisible && (
            <button
              className={styles.code}
              onClick={() => setHelpTextVisible(true)}
            >
              {t('Forgot the code?')}
            </button>
          )}
          {isHelpTextVisible && t('Contact customer service')}
        </div>
      )}
      <Button
        variant="contained"
        size="medium"
        active
        className={styles.button}
        disabled={!isActivationCodeCorrect}
        onClick={handleUnlock}
      >
        {t('Confirm and play')}
      </Button>
    </>
  );
};

export { ActivatedParentalControls };
